import getCurrentMainDomain from './getCurrentMainDomain'

export default function getSubdomain() {
  return String(window.location.hostname).slice(0, -(getCurrentMainDomain().length + 1))
}
